<h2 mat-dialog-title>Give / Take Coins</h2>
<mat-dialog-content>
  <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px;">
    <mat-icon color="primary">payments</mat-icon>
    <span>
      Current balance:
      <b>{{formatNumber(playerCoins!)}}</b>
      coins
    </span>
    <span style="opacity: 0.75;" *ngIf="data?.player?.username">for {{data.player.username}}</span>
  </div>
  <div style="display: flex; gap: 12px; align-items: flex-end; flex-wrap: wrap;">
    <mat-form-field appearance="outline" style="width: 140px;">
      <mat-label>Action</mat-label>
      <mat-select [(ngModel)]="mode">
        <mat-option value="give">Give</mat-option>
        <mat-option value="take">Take</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 180px;">
      <mat-label>Amount</mat-label>
      <input matInput type="number" min="1" [(ngModel)]="amount">
    </mat-form-field>

    <mat-form-field appearance="outline" style="flex: 1 1 320px; min-width: 240px;">
      <mat-label>Reason (optional)</mat-label>
      <input matInput [(ngModel)]="reason" maxlength="200">
      <mat-hint align="end">{{reason.length || 0}} / 200</mat-hint>
    </mat-form-field>

    <!-- Bearer token input removed; token is provided by environment configuration -->
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="primary" [disabled]="!canSubmit" (click)="submit()">Confirm</button>

</mat-dialog-actions>
